import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseCreatePublicCompanyLeadContractEquipmentCategoryProps {
  publicCompanyLeadId?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useCreatePublicCompanyLeadContractEquipmentCategory = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseCreatePublicCompanyLeadContractEquipmentCategoryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createPublicCompanyLeadContractEquipmentCategory'],
    mutationFn: async (data: { label: string; value: string }) => {
      const lead = {
        contract_attributes: {
          contract_equipment_categories_attributes: [
            {
              equipment_category_id: data.value,
              quantity: 1,
            },
          ],
        },
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
